"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateMerchIdOrGetDefault = exports.validateServicesOrGetDefault = exports.validateAddonsOrGetDefault = exports.validateUnitQuantityOrGetDefault = exports.validateTermOrGetDefault = exports.validateEditionOrGetDefault = void 0;

var _underscore = require("underscore");

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var Terms = _interopRequireWildcard(require("self-service-api/constants/Terms"));

var _HubToAddonsMap = require("pricing-pages-unified-ui/constants/HubToAddonsMap");

var _HubToServicesMap = require("pricing-pages-unified-ui/constants/HubToServicesMap");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var validateEditionOrGetDefault = function validateEditionOrGetDefault(edition) {
  var defaultEdition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Editions.STARTER;
  return Object.values(Editions).includes(edition) ? edition : defaultEdition;
};

exports.validateEditionOrGetDefault = validateEditionOrGetDefault;

var validateTermOrGetDefault = function validateTermOrGetDefault(term) {
  var defaultTerm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Terms.ANNUAL;
  return Object.values(Terms).includes(term) ? term : defaultTerm;
};

exports.validateTermOrGetDefault = validateTermOrGetDefault;

var validateUnitQuantityOrGetDefault = function validateUnitQuantityOrGetDefault(quantity) {
  var defaultQuantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Number.isInteger(quantity) && quantity > -1 ? quantity : defaultQuantity;
};

exports.validateUnitQuantityOrGetDefault = validateUnitQuantityOrGetDefault;

var validateAddonsOrGetDefault = function validateAddonsOrGetDefault(merchandiseIds) {
  var defaultMerchIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!Array.isArray(merchandiseIds)) return defaultMerchIds;
  return (0, _underscore.difference)(merchandiseIds, _HubToAddonsMap.AllAddons).length === 0 ? merchandiseIds : defaultMerchIds;
};

exports.validateAddonsOrGetDefault = validateAddonsOrGetDefault;

var validateServicesOrGetDefault = function validateServicesOrGetDefault(merchandiseIds) {
  var defaultMerchIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!Array.isArray(merchandiseIds)) return defaultMerchIds;
  return (0, _underscore.difference)(merchandiseIds, _HubToServicesMap.AllServices).length === 0 ? merchandiseIds : defaultMerchIds;
};

exports.validateServicesOrGetDefault = validateServicesOrGetDefault;

var validateMerchIdOrGetDefault = function validateMerchIdOrGetDefault(merchId, hub) {
  var defaultMerchId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isInMCBeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var highlightedPaidMerch = isInMCBeta ? _HubMap.default[hub].highlightedPaidMerchMCBeta : _HubMap.default[hub].highlightedPaidMerch;
  return highlightedPaidMerch.includes(merchId) ? merchId : defaultMerchId;
};

exports.validateMerchIdOrGetDefault = validateMerchIdOrGetDefault;